import { useCallback } from 'react';

import { useGoBack } from '@libs/hooks/useGoBack';

import { useAuth } from '@features/auth/hooks/useAuth';
import { Achievement } from '@features/shared/api/typings';
import { useAchievementsListQuery } from '@features/shared/api/user';
import { PlayerAchievementsPage } from '@features/user/pages/PlayerAchievementsPage/PlayerAchievementsPage';
import { UserAuthMenuWidget } from '@features/user/ui/UserAuthMenu/UserAuthMenuWidget';
import { UserSettingsMenuWidget } from '@features/user/ui/UserSettingsMenu/UserSettingsMenuWidget';

export function PlayerAchievementsPageWidget() {
  const onBack = useGoBack();
  const handleDownload = useCallback((achievement: Achievement) => {
    window.open(achievement.tournamentCertificate?.downloadLink, '_blank');
  }, []);

  const user = useAuth().user;
  const userId = user?.userId;

  const { data } = useAchievementsListQuery({ userId: userId || '', enabled: !!userId });

  return (
    <PlayerAchievementsPage
      achievements={data?.items}
      actions={
        <>
          <UserSettingsMenuWidget />
          <UserAuthMenuWidget />
        </>
      }
      onItemDownload={handleDownload}
      onBack={onBack}
    />
  );
}
